import * as React from 'react';

const SendMessage = (props: React.SVGAttributes<SVGElement>) => (
	<svg viewBox="0 0 21 18" {...props}>
		<path
			fill="currentColor"
			fillRule="evenodd"
			d="M.01 18L21 9 .01 0 0 7l15 2-15 2z"
		/>
	</svg>
);

export default SendMessage;
